import React from "react";
import { Typography } from "@mui/material";

function SettingsPage() {
    return(
        <div>
            <Typography variant="h6"  gutterBottom>
            Settings
            </Typography>
            <Typography variant="body1" gutterBottom>
                Settings is essential ...
            </Typography>
        </div>        
    )
}

export default SettingsPage;
